import { EndOutcome } from '../types';

export type JuniorSessionResult = {
	state: 'completed' | 'interrupted';
	duration: number;
	correct_ratio: number;
};

export const createJuniorSessionResult = (
	outcome: EndOutcome,
	duration: number,
	correctRatio: number,
): JuniorSessionResult => ({
	state: outcome === EndOutcome.ABANDONED ? 'interrupted' : 'completed',
	duration: Math.max(0.001, duration),
	correct_ratio: Math.min(1, Math.max(0, correctRatio)),
});
